import { Button, Flex, Text, TextField, Select, Spinner, AlertDialog, Strong } from '@radix-ui/themes'
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import axios from 'axios';
import api from '../../../api';
import { InfoCircledIcon } from '@radix-ui/react-icons';
import { updateFinanceWithdrawals, updateFinanceAvailableBalance } from '../../../redux/slices/financeSlice';


const WithdrawalForm = ({ setShowForm }) => {
    const [loading, setLoading] = useState(false);
    const [verificationDetails, setVerificationDetails] = useState({});
    const [formValues, setFormValues] = useState({});
    const [networks, setNetworks] = useState([]);
    const dispatch = useDispatch();
    const finance = useSelector((state) => state.finance);
    const [userBalance, setUserBalance] = useState(100);
    const [showConfirmWithdrawalModal, setShowConfirmWithdrawalModal] = useState(false);


    useEffect(() => {
        console.log('verificationDetails::', verificationDetails)
    }, [verificationDetails])

    const formik = useFormik({
        initialValues: {
            countryCode: finance?.account?.payment_details?.country_code ? finance.account.payment_details.country_code : '233',
            phoneNumber: finance?.account?.payment_details?.phone_number ? finance.account.payment_details.phone_number : '',
            network: finance?.account?.payment_details?.network ? finance.account.payment_details.network : '',
            amount: '10'
        },
        validationSchema: Yup.object({
            countryCode: Yup.string()
                .matches(/^[1-9]{1}[0-9]{1,3}$/, 'Invalid country code') // Validates international country codes
                .required('Country code is required'),
            phoneNumber: Yup.string()
                .matches(/^[0-9]{7,10}$/, 'Phone number must be between 7 and 10 digits') // Validates phone number without country code
                .required('Phone number is required'),
            network: Yup.string()
                .required('Network is required'),
            amount: Yup.number()
                .min(10, 'Amount must be greater than 10')
                .required('Amount is required')
                .test('is-valid-amount', function (value) {
                    const { path, createError } = this;
                    const maxAmount = userBalance;  // Ensure userBalance is available in the context

                    // Check if the user has no available balance
                    if (maxAmount <= 0) {
                        return createError({
                            path,
                            message: 'You cannot withdraw because you have no funds available.',
                        });
                    }

                    // Check if the value exceeds the available balance
                    if (value > maxAmount) {
                        return createError({
                            path,
                            message: `Amount exceeds available balance. You can withdraw up to GHS ${maxAmount}`,
                        });
                    }

                    // Check if the value is a whole number
                    if (!Number.isInteger(value)) {
                        return createError({
                            path,
                            message: 'Amount must be a whole number.',
                        });
                    }

                    return true;
                })
        }),
        onSubmit: async (values) => {
            console.log('checking values::', values.amount);
            console.log('checking finance.availableBalance::', finance.availableBalance);
            if (values.amount > finance.availableBalance) {
                toast.error('You do not have enough funds available', { type: 'danger' });
            } else {
                setFormValues(values);
                handleVerifyAccount(values);
            }

        }
    })


    const fetchNetworksAndBanks = async () => {
        try {
            const response = await axios.get('https://api.paystack.co/bank?currency=GHS');
            const banksData = response.data.data || [];

            // Convert to lowercase for filtering and filter out MTN, Vodafone, AirtelTigo, and Bank of Ghana for banks
            // const filteredBanks = data.filter(bank => {
            //     const bankNameLower = bank.name.toLowerCase();
            //     return !['mtn', 'vodafone', 'airteltigo', 'bank of ghana'].includes(bankNameLower);
            // });

            // Convert to lowercase for filtering and include only MTN, Vodafone, AirtelTigo for networks
            const filteredNetworks = banksData.filter(bank => {
                return bank.type === 'mobile_money';
            });
            console.log('Networks', filteredNetworks);

            setNetworks(filteredNetworks);
        } catch (error) {
            console.error(error);
            setNetworks(PAYSTACK_NETWORKS)
            // Alert.alert('Error', 'Failed to load networks or banks.');
        } finally {
            setLoading(false)
        }
    };

    const handleVerifyAccount = async (values) => {
        try {
            setLoading(true)
            const data = {
                account_number: `${values.countryCode}${Number(values.phoneNumber)}`,
                bank_code: values.network, // Using selected network or bank for bank_code
            }
            console.log('sending data', data);
            const response = await api.get('/verify-account', {
                params: data,
            });
            console.log('verify account response:', response.data)

            setVerificationDetails(response.data.verification)

            setShowConfirmWithdrawalModal(true)
        } catch (error) {
            console.error('Error verifying account:', error);
            toast.error("Couldn't get mobile money details, try again later", {
                type: 'danger',
            });
        } finally {
            setLoading(false)
        }
    };

    const handleMakeTransfer = async () => {
        try {
            setLoading(true);
            // const token = await getStoredAuthToken('authToken');
            const data = {
                name: verificationDetails.account_name,
                account_id: finance.account.id,
                account_number: verificationDetails.account_number,
                type: 'mobile_money',
                bank_code: formValues.network
            }
            const reciptResponse = await api.post('/generate-receipt', data);
            console.log('Generate Receipt response:', reciptResponse)


            const makeTransferdata = {
                amount: formValues.amount,
                recipient_code: reciptResponse.data.receipt.recipient_code,
                payment_method: reciptResponse.data.receipt.type,
                account_id: finance.account.id
            }

            console.log('transfer post data:', makeTransferdata)

            const transferResponse = await api.post('/make-transfer', makeTransferdata);
            console.log('Transfer response:', transferResponse.data)

            dispatch(updateFinanceWithdrawals([transferResponse.data.withdrawal_request, ...finance.withdrawals]))
            dispatch(updateFinanceAvailableBalance(transferResponse.data.availableBalance));

            toast.success("Transfer request made successful, Transfer may take up to 24 to 48 hours to credit your account",
                { duration: 10000, type: 'success_with_close_button', placement: 'top' })

            setFormValues({
                amount: '',
                countryCode: '233',
                phoneNumber: '',
                network: ''
            });

            //Close Modal
            setShowConfirmWithdrawalModal(false)
            setShowForm(false)

        } catch (error) {
            console.error('Error making transfer:', error);
            toast.error(`Couldn't make transer, try again`, {
                type: 'danger',
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchNetworksAndBanks()
    }, [])



    return (
        <div>
            <form onSubmit={formik.handleSubmit}>
                {formik.status && (
                    <Flex direction="column" justify="center" align="center">
                        <Text color="red" mb="4">{formik.status}</Text>
                    </Flex>
                )}

                <Flex direction="column" gap="1">
                    <Text><Strong>Country Code</Strong></Text>
                    <TextField.Root size="3"
                        name="countryCode"
                        value={formik.values.countryCode}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        placeholder="Country Code"
                        disabled={true}
                    />
                    {formik.touched.countryCode && formik.errors.countryCode &&
                        <Text color="red" size="2">{formik.errors.countryCode}</Text>
                    }

                    <Text><Strong>Phone Number</Strong></Text>
                    <TextField.Root size="3"
                        name="phoneNumber"
                        value={formik.values.phoneNumber}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        placeholder="Phone Number"
                    />
                    {formik.touched.phoneNumber && formik.errors.phoneNumber &&
                        <Text color="red" size="2">{formik.errors.phoneNumber}</Text>
                    }

                    <Text><Strong>Network</Strong></Text>
                    <Select.Root
                        name="network"
                        value={formik.values.network}
                        onValueChange={(value) => formik.setFieldValue('network', value)}
                    >
                        <Select.Trigger />
                        <Select.Content>
                            <Select.Item value=" ">Select a network</Select.Item>
                            {networks.map((network) => (
                                <Select.Item value={network.code}>{network.name}</Select.Item>
                            ))}
                        </Select.Content>
                    </Select.Root>
                    {formik.touched.network && formik.errors.network && (
                        <Text style={{ color: 'red' }}>{formik.errors.network}</Text>
                    )}

                    <Text><Strong>Amount</Strong></Text>
                    <TextField.Root size="3"
                        name="amount"
                        value={formik.values.amount}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        placeholder="Amount"
                    />
                    {formik.touched.amount && formik.errors.amount &&
                        <Text color="red" size="2">{formik.errors.amount}</Text>
                    }

                    <Button disabled={loading} type="submit" mt="3">
                        {loading ? (
                            <Flex gap="2" align="center">
                                <Spinner size="1" />
                                Loading...
                            </Flex>
                        ) : (
                            'Submit Withdrawal Request'
                        )}
                    </Button>


                    <AlertDialog.Root open={showConfirmWithdrawalModal} onOpenChange={setShowConfirmWithdrawalModal}>
                        <AlertDialog.Content>
                            <AlertDialog.Title>Confirm Withdrawal</AlertDialog.Title>
                            <Flex direction="column" gap="4">


                                <div className="space-y-4">
                                    {/* Info Pill */}
                                    <div className="flex items-center gap-2 bg-[#30a46c] p-4 rounded mb-4">
                                        <InfoCircledIcon size={32} color="#fff" />
                                        <p className="text-white flex-1 text-lg">
                                            You are about to approve transfer to the account below
                                        </p>
                                    </div>

                                    {/* Wallet Details */}
                                    <div>
                                        <div className="mb-4">
                                            <p className="text-lg font-bold">Wallet Name</p>
                                            <p className="text-xl text-primary mb-2">{verificationDetails?.account_name}</p>
                                        </div>

                                        <div className="mb-4">
                                            <p className="text-lg font-bold">Network</p>
                                            <p className="text-xl text-primary mb-2">{formValues.network}</p>
                                        </div>

                                        <div className="mb-4">
                                            <p className="text-lg font-bold">Phone Number</p>
                                            <p className="text-xl text-primary mb-2">+{verificationDetails?.account_number}</p>
                                        </div>

                                        <div className="mb-4">
                                            <p className="text-lg font-bold">Amount</p>
                                            <p className="text-xl text-primary mb-2">GHS {formValues.amount}</p>
                                        </div>
                                    </div>

                                    {/* Withdrawal Notice */}
                                    <div className="flex items-center gap-2 justify-end">
                                        <InfoCircledIcon size={24} color="#266eb6" />
                                        <p className="text-base">
                                            Withdrawal may take up to 48 hours
                                        </p>
                                    </div>
                                </div>


                            </Flex>
                            <Flex justify="end" gap="3" mt="4">
                                <Button
                                    onClick={handleMakeTransfer}

                                    color="green"
                                >
                                    {loading ? (
                                        <Flex gap="2" align="center">
                                            <Spinner size="1" />
                                            Loading...
                                        </Flex>
                                    ) : (
                                        'Transfer'
                                    )}
                                </Button>
                                <Button variant="soft" onClick={() => setShowConfirmWithdrawalModal(false)}>
                                    Cancel
                                </Button>
                            </Flex>
                        </AlertDialog.Content>
                    </AlertDialog.Root>


                </Flex>
            </form>
        </div>
    );
};

export default WithdrawalForm;
